import { css } from '@emotion/css';
import { useNavigate, useParams } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import ProfileOrderDetails from '../../../features/profile/components/profile-order-details/profile-order-details';

const container = css({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: 'var(--spacing-xl) var(--spacing-md)',
  '@media (max-width: 768px)': {
    padding: 'var(--spacing-lg) var(--spacing-sm)',
  },
  '@media print': {
    padding: 0,
    margin: 0,
    maxWidth: 'none',
  },
});

const backButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--spacing-2xs)',
  background: 'none',
  border: 'none',
  color: 'var(--pc-600)',
  fontSize: 'var(--fs-350)',
  fontWeight: 500,
  cursor: 'pointer',
  padding: 'var(--spacing-xs) 0',
  marginBottom: 'var(--spacing-lg)',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: 'var(--pc-700)',
  },
  '@media print': {
    display: 'none',
  },
});

export function ProfileOrderDetailsPage() {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();

  if (!orderId) {
    return (
      <div className={container}>
        <p>ID do pedido não fornecido.</p>
      </div>
    );
  }

  return (
    <div className={container}>
      <button className={backButton} onClick={() => navigate('/perfil/compras')}>
        <FiChevronLeft size={20} />
        Voltar para compras
      </button>
      <ProfileOrderDetails orderId={orderId} />
    </div>
  );
}

export default ProfileOrderDetailsPage;
